import { render, staticRenderFns } from "./Openticket.vue?vue&type=template&id=107175d2"
import script from "./Openticket.vue?vue&type=script&lang=js"
export * from "./Openticket.vue?vue&type=script&lang=js"
import style0 from "./Openticket.vue?vue&type=style&index=0&id=107175d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports